import { useNavigate, useLocation } from "react-router-dom";

export const useDirection = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const pathMap = {
    "/about": "/hakkimizda",
    "/hakkimizda": "/about",
    "/stations": "/istasyonlar",
    "/istasyonlar": "/stations",
    "/faq": "/sss",
    "/sss": "/faq",
    "/partner": "/is-ortaklarimiz",
    "/is-ortaklarimiz": "/partner",
    "/ucretler": "/wages",
    "/wages": "/ucretler",
    "/indirme": "/download",
    "/download": "/indirme",
    "/contact": "/iletisim",
    "/iletisim": "/contact",
    "/uyelik-sozlesmesi": "/membership-contract",
    "/membership-contract": "/uyelik-sozlesmesi",
    "/gizlilik-sozlesmesi": "/privacy-policy",
    "/privacy-policy": "/gizlilik-sozlesmesi",
    "/satis-sozlesmesi": "/sales-contract",
    "/mesafeli-satis-sozlesmesi": "/distance-sales-agreement",
    "/distance-sales-agreement": "/mesafeli-satis-sozlesmesi",
    "/iptal-ve-iade-kosullari": "/cancellation-and-refund-conditions",
    "/cancellation-and-refund-conditions": "/iptal-ve-iade-kosullari",
  };

  const changeDirection = () => {
    const currentPath = location.pathname;
    if (pathMap[currentPath]) {
      navigate(pathMap[currentPath]);
    }
  };

  return changeDirection;
};